module.exports = __webpack_public_path__ + "img/13.ae336f43.jpg";